<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(storeCliente)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Registro Cliente</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errores">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                        </ul>
                    </b-alert>
                    <b-row>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="tipo_documento"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Tipo Documento:"
                                    label-for="tipo_documento">
                                    <b-form-select
                                        v-model="tipo_documento"
                                        :options="tipoDocumentoCliente"
                                        id="tipo_documento"
                                        class="mb-3"
                                        value-field="tipo"
                                        text-field="label"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        disabled-field="notEnabled"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="documento"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Numero de Documento:"
                                    label-for="documento">
                                    <b-form-input
                                        id="documento"
                                        v-model="documento"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el numero de documento"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="cliente"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Cliente:"
                                    label-for="cliente">
                                    <b-form-input
                                        id="cliente"
                                        v-model="register.cliente"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Email"  rules="required|email" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Email:"
                                    label-for="email">
                                    <b-form-input
                                        id="email"
                                        v-model="register.correo"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el correo"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="telefono"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group
                                    label="Telefono:"
                                    label-for="telefono">
                                    <b-form-input
                                    id="telefono"
                                    v-model="register.telefono"
                                    type="text"
                                    autocomplete="off"
                                    required
                                    placeholder="Ingrese el telefono"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="departamento"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Departamento:"
                                    label-for="departamento">
                                    
                                    <b-form-select
                                        v-model="departamento"
                                        :options="departamentos_list"
                                        id="departamento"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        @change="getCiudadesList()"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="ciudad"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Ciudad:"
                                    label-for="ciudad">
                                   
                                    <b-form-select
                                        v-model="ciudad"
                                        :options="ciudades_list"
                                        id="ciudad"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="12">
                            <ValidationProvider name="direccion"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Dirección:"
                                    label-for="direccion">
                                    <b-form-textarea
                                        id="direccion"
                                        v-model="direccion"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese la dirección"
                                        ></b-form-textarea>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Registrar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('configuration', ['tipoDocumentoCliente'])
    },
    data(){
        return{
            register: {
                cliente:  "",
                correo: "",
                telefono: "",
            },
            errors: {},
            errores: false,
            tipo_documento_list: [],
            tipo_documento: '',
            documento: '',
            departamento: '',
            ciudad: '',
            direccion: '',
            departamentos_list: [],
            ciudades_list: [],
        }
    },
    created(){
        this.getDepartamentosList();
    },
    methods: {
        ...mapMutations(['setLoading']),
        back(){
            this.$router.go(-1);
        },
        async storeCliente(){
            this.errors = {};
            this.errores = false;
            this.setLoading(true)
            this.register.documento      = this.documento;
            this.register.tipo_documento = this.tipo_documento;
            this.register.direccion      = this.direccion;
            this.register.ciudad         = this.ciudad;
            this.register.departamento   = this.departamento;
            await this.$conectar.post('/clientes/store-cliente', this.register)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'ListadoClientes' });
                }
            })
            .catch(response =>{
                console.log(response);
                this.$root.$bvToast.toast("Error en el servidor, favor intente nuevamente", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            this.ciudad = '';
            this.departamentoSelected = { 
                departamento_id:   this.departamento, 
            }
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
            .then(response =>{
                this.ciudades_list = response.data.ciudadesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
    }
    
}
</script>